// Module
var code = `<div class="banner-slider"
    id="slider">
    <div class="banner-slider__carousel owl-carousel">
        <div class="banner-slider__slide"
            ng-repeat="slide in \$ctrl.slider">
            <div class="banner-slider__container container container--space">
                <div class="row align-items-lg-center">
                    <div class="col-lg-6 col-xl-7"
                        ng-class="{'order-xl-6': !slide.layoutChange}">
                        <img ng-src="{{slide.imageContent}}"
                            alt="">

                    </div>
                    <div class="col-lg-6 col-xl-5">
                        <h2 ng-bind-html="slide.title"
                            class="banner-slider__title text-center text-lg-left">
                        </h2>

                        <div class="banner-slider__description text-center text-lg-left"
                            ng-bind-html="slide.subtitle"></div>

                        <div class="banner-slider__stores justify-content-center justify-content-lg-start d-flex"
                            ng-if="slide.stores && slide.stores.length">
                            <a class="banner-slider__store"
                                ng-repeat="store in slide.stores track by \$index"
                                ng-href="{{ store.link }}"
                                target="_blank"
                                rel="noopener">
                                <img ng-src="{{ store.image }}"
                                    alt="{{ store.alt }}" />
                            </a>
                        </div>
                        <div class="banner-slider__link-box d-flex justify-content-center justify-content-lg-start">
                            <a ng-href="{{slide.url}}"
                                class="banner-slider__link link-global link-global--block">
                                {{slide.link}}
                            </a>
                        </div>


                    </div>
                </div>


            </div>
        </div>
    </div>
</div>`;
// Exports
export default code;